export default function TicketButton({ ...rest }) {
  // Shadowed by bottlebooks-site-cms
  return null;
}
